import React from 'react';
import { PdfDownloadButton } from '../pdf-download-button/pdf-download-button';
import { CourseDetailsPdf, createAndSavePdf } from '../course-details-pdf/course-details-pdf';

export type PdfDownloadButtonProps = {
  courseDetailsPdfData;
  translations;
  currentLocale;
  fileName;
};

// The idea of this component is to load all pdf libraries on demand with await import
const CourseDetailsPdfButton: React.FC<PdfDownloadButtonProps> = ({
  courseDetailsPdfData,
  translations,
  currentLocale,
  fileName,
}) => {
  const onDownloadClick = React.useCallback(async () => {
    await createAndSavePdf(
      <CourseDetailsPdf
        data={courseDetailsPdfData}
        translations={translations}
        currentLocale={currentLocale}
      />,
      fileName,
    );
  }, [courseDetailsPdfData, currentLocale, fileName, translations]);

  return <PdfDownloadButton onDownloadClick={onDownloadClick} />;
};

export default CourseDetailsPdfButton;
